// Copyright (C) 2020 One More Game - All Rights Reserved
// Unauthorized copying of any files within this project, via any medium, is strictly prohibited
// Proprietary and confidential

import React, { useState } from "react"
import { useForm } from "react-hook-form"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import * as styles from "./styles.module.scss"

enum FormState {
  READY,
  SENDING,
  REGISTERED,
  ERRORED,
}

interface ErrProps {
  message: string
}

const ErrMessage: React.FC<ErrProps> = ({ message }: ErrProps) => {
  return <div className={styles.errMessage}>{message}</div>
}

interface InputProps {
  disabled: boolean
  register: any
}

const FormInput: React.FC<InputProps> = ({
  register,
  disabled,
}: InputProps) => {
  // This is the 'minimum regex' which This regex will determine if
  const emailRegex = /.+@.+\..+/i
  return (
    <input
      className={styles.emailField}
      disabled={disabled}
      type="text"
      name="email"
      autoComplete="off"
      data-required="true"
      placeholder="Enter your email address to sign up for our newsletter"
      { ... register("email", {
        required: "Please fill in your email and try again",
        pattern: {
          value: emailRegex,
          message:
            "The email address you entered is invalid. Please try again.",
        },
      })}
    />
  )
}

interface BtnProps {
  formState: FormState
}

const SubmitBtn: React.FC<BtnProps> = ({ formState }) => {
  let disabled = formState !== FormState.READY
  return (
    <button
      className={`${styles.submit} ${disabled && styles.submitDisabled}`}
      disabled={disabled}
      type="submit"
    >
      Submit
    </button>
  )
}

const NewsLetterSignup: React.FC = () => {
  const data = useStaticQuery(graphql`
    query {
      imageIcon: file(relativePath: { eq: "newsletter-icon.png" }) {
        childImageSharp {
          fluid(maxWidth: 39, maxHeight: 26) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  const { handleSubmit, register, formState: { errors } } = useForm()
  const [formState, setFormState] = useState(FormState.READY)

  const onSubmit = data => {
    let formData = new FormData()
    formData.append("EMAIL", data["email"])
    formData.append("locale", "en")

    try {
      setFormState(FormState.SENDING)
      fetch(
        "https://sibforms.com/serve/MUIEAOnivRcBwg0eiURdIxF-mNghEvt0m5n2TsRiGD5RG7xnk9jAAth8ytQ5RN0b2dNu3EKmJlgK7-sI3cjHg_IV6mmYQyIWJuWJON-kTeb1iVRYwk6vARhb-g_AMPSbWk8OWNLx-N-aTFXwSpENbTS_J44ttM-tzSX9L4yFJ8RroxOfJPUwh9Cb6ZU31rpF6P7rCHib8DpHH9OW?isAjax=1",
        {
          method: "POST",
          body: formData,
        }
      )
        .then(response => {
          setFormState(FormState.REGISTERED)
        })
        .catch(e => setFormState(FormState.READY))
    } catch (e) {
      console.log(e)
      setFormState(FormState.ERRORED)
    }
  }

  let controls
  if (formState === FormState.REGISTERED) {
    controls = (
      <div className={styles.registered}>
        <p>Thank you for subscribing!</p>
      </div>
    )
  } else if (formState === FormState.SENDING) {
    controls = (
      <div className={styles.sending}>
        <p>Registering...</p>
      </div>
    )
  } else if (formState === FormState.ERRORED) {
    controls = (
      <div className={styles.errored}>
        <p>
          We're sorry but there was an error. Reload the page and try again.
        </p>
      </div>
    )
  } else {
    controls = (
      <div className={styles.wrapper}>
        <div className={styles.col1}>
          <div className={styles.icon}>
            <Img
              fluid={data.imageIcon.childImageSharp.fluid}
              alt="An envelope"
            />
          </div>
        </div>
        <div className={styles.col2}>
          <FormInput
            register={register}
            disabled={formState !== FormState.READY}
          />
          {errors.email && <ErrMessage message={errors.email.message?.toString() ?? ''} />}
        </div>
        <div className={styles.col3}>
          <SubmitBtn formState={formState} />
        </div>
      </div>
    )
  }

  return (
    <div id="newsletter-signup" className={styles.container}>
      <h2 className={styles.title}>Stay updated with our happenings</h2>
      <form onSubmit={handleSubmit(onSubmit)}>{controls}</form>
    </div>
  )
}

export default NewsLetterSignup
